export default __webpack_public_path__ + "static/media/klaus_xl.5f5b444e.jpg";